export function transactionExplorerUrl(txid: string): string {
  return `https://memepool.space/tx/${txid}`;
}

export function inscriptionExplorerUrl(txid: string, index = 0): string {
  return `https://ordinals.com/inscription/${txid}i${index}`;
}
